export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000';
export const COGNITO_DOMAIN = process.env.REACT_APP_COGNITO_DOMAIN;
export const COGNITO_CLIENT_ID = process.env.REACT_APP_COGNITO_CLIENT_ID;

// File upload configuration
export const MAX_FILE_SIZE_MB = parseInt(process.env.REACT_APP_MAX_FILE_SIZE_MB || '50');
export const PRESIGNED_URL_THRESHOLD_MB = parseInt(process.env.REACT_APP_PRESIGNED_URL_THRESHOLD_MB || '5');
export const ALLOWED_FILE_EXTENSIONS = ['.json', '.csv', '.xlsx', '.xls'];